import Input from "../../components/Input";
import Select from "../../components/Select";

export default function JuniorFields({
	translate,
	lang,
	data,
	handleUpdate,
	errors,
}) {
	return (
		<>
			<div className="form-group">
				<Input
					name="parentFname"
					label={translate(lang, "Nombre(s)", "Nombre(s)")}
					reqd={true}
					value={data.parentFname || ""}
					update={handleUpdate}
					errors={errors}
					autocomplete="given-name"
				/>

				<Input
					name="parentLname"
					label={translate(lang, "Apellidos", "Apellidos")}
					reqd={true}
					value={data.parentLname || ""}
					update={handleUpdate}
					errors={errors}
					autocomplete="family-name"
				/>
			</div>

			<div className="form-group">
				<Input
					name="email"
					label={translate(lang, "Correo Electrónico", "Correo Electrónico")}
					reqd={true}
					value={data.email || ""}
					update={handleUpdate}
					errors={errors}
					autocomplete="email"
				/>

				<div className="two-inputs">
					<Select
						name="phoneCode"
						label={translate(lang, "Código del País", "Código del País")}
						reqd={true}
						value={data.phoneCode || ""}
						options={[
							{
								id: "+1",
								name: "US / CA (+1)",
							},
							{
								id: "+52",
								name: "MX (+52)",
							},
							{
								id: "other",
								name: `${translate(lang, "Otros", "Otros")}`,
							},
						]}
						update={handleUpdate}
						errors={errors}
						autocomplete="tel-country-code"
					/>
					<Input
						name="phone"
						label={translate(lang, "Teléfono Celular", "Teléfono Celular")}
						reqd={true}
						value={data.phone || ""}
						update={handleUpdate}
						errors={errors}
						autocomplete="tel-national"
					/>
				</div>
			</div>

			<div className="form-group">
				<Input
					name="residence"
					label={translate(lang, "Residencia", "Residencia")}
					reqd={true}
					value={data.residence || ""}
					update={handleUpdate}
					errors={errors}
					autocomplete="off"
				/>

				<Select
					name="st2"
					label={translate(lang, "State", "Estado")}
					reqd={true}
					value={data.st2 || ""}
					options={[
						{
							id: "",
							name: "--",
						},
					].concat(
						[
							"Aguascalientes",
							"Baja California",
							"Baja California Sur",
							"Campeche",
							"Chiapas",
							"Chihuahua",
							"Coahuila",
							"Colima",
							"Durango",
							"Guanajuato",
							"Guerrero",
							"Hidalgo",
							"Jalisco",
							"México",
							"Mexico City",
							"Michoacán",
							"Morelos",
							"Nayarit",
							"Nuevo León",
							"Oaxaca",
							"Puebla",
							"Querétaro",
							"Quintana Roo",
							"San Luis Potosí",
							"Sinaloa",
							"Sonora",
							"Tabasco",
							"Tamaulipas",
							"Tlaxcala",
							"Veracruz",
							"Yucatán",
							"Zacatecas",
						].map((item) => {
							return {
								id: item,
								name: item,
							};
						}),
					)}
					update={handleUpdate}
					errors={errors}
					autocomplete="address-level1"
				/>
			</div>
		</>
	);
}
